import React from 'react';

import { useNavigate } from 'react-router';

import Layout from '../components/common/Layout';

const ApplicationSubmittedPage = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="wait-list-page">
        <div className="page-inner">
          <h2>Application Submitted</h2>
          <div className="main-message">
            <p>
              <b>What it means:</b> You have submitted a complete application and it is currently
              under review for eligibility.
            </p>
            <p>
              <b>What you should do:</b> We will review your application and notify you via email if
              additional documentation or information is needed.
            </p>
          </div>
          <div className="button-groups d-flex">
            <button className="primary-btn" onClick={() => navigate('/dashboard')}>
              Return to Dashboard
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ApplicationSubmittedPage;
